import React, { Component } from 'react';
import './add-section.scss';
import Dropdown from '../../common/dropdown-v2/dropdown';
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import SchoolApi from '../../../apis/school'
import ExcelToJson from '../../common/excel-to-json/excel-to-json';
import SessionCache from '../../routes/session-cache';
import AddNewTeacher from '../../teachers/add-new-contact/add-new-contact';
import { Modal, ModalBody } from "reactstrap";

class AddSection extends Component {

    state = {
        sections: [],
        mathsHodDropdown: [],
        mathTeacherDropdown: [],
        selectedHeader: 0,
        currentActiveSectionOrder: 1,
        oldSection: this.props.oldSection,
        type: this.props.oldSection?.length ? "OLD" : "NEW"
    };

    constructor(props) {
        super(props)
        let sectionCount = props.numberOfSections
        if (props.oldSection?.length) {
            sectionCount += props.oldSection?.length || 0

            for (let i = 0; i < props.oldSection?.length; i++) {
                let section = props.oldSection[i]
                let payload = {
                    sectionName: section?.section,
                    teacher: section.teacher?._id,
                    strength: section.strength,
                    notEditable: true,
                    completed: true
                }
                if (i == 0) {
                    this.state.currentPayload = payload
                }
                this.state[i + 1] = payload
            }

        }
        for (let i = 0; i < sectionCount; i++) {
            this.state.sections.push(
                {
                    title: `Section ${i + 1}`,
                    order: i + 1
                }
            )
        }

        if (this.props.mode == "EDIT") {
            let currentPayload = {
                sectionName: props.sectionDetails?.section,
                hod: props.sectionDetails?.mathsHod?._id,
                teacher: props.sectionDetails?.mathTeacher?._id
            }
            this.state.currentPayload = currentPayload
        }

    }

    componentDidMount() {
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })
        this.getStaffs()
    }

    getStaffs(payload = {}) {
        payload.types = `in/MATH_TEACHER`
        SchoolApi.getStaffs(payload)
            .then(staffs => {
                let classTeachers = [], mathTeachers = [], mathTeachersHash = {};
                for (let i = 0; i < staffs?.response?.length; i++) {
                    let staff = staffs?.response[i]

                    for (let j = 0; j < staff?.types?.length; j++) {
                        let type = staff?.types[j]
                        if (!mathTeachersHash[staff._id]) {
                            mathTeachersHash[staff._id] = true
                            mathTeachers.push({
                                title: staff.firstName,
                                value: staff._id,
                            })
                        }
                    }

                }
                this.setState({ mathsHodDropdown: classTeachers, mathTeacherDropdown: mathTeachers, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })
    }

    onClickHeader(item, index) {
        let order = this.state.currentActiveSectionOrder || 1
        let previousPayload = {
            ...this.state.currentPayload
        }

        let currentPayload = this.state[item.order] || {}

        this.setState({
            [order]: previousPayload,
            currentPayload,
            selectedHeader: index,
            currentActiveSectionOrder: item.order,
            reloadDropdown: true
        }, () => {
            this.setState({ reloadDropdown: false })
        })

    }

    onChangeHandler = (event, key) => {
        let currentPayload = {
            ...this.state.currentPayload,
            [key]: event.target.value
        }
        let completed = this.checkCompletedStatus(currentPayload)
        let sections = this.state.sections
        sections[this.state.selectedHeader].completed = completed

        this.setState({ currentPayload, sections }, () => {
            this.emitChanges()
        })
    }

    checkCompletedStatus(currentPayload) {
        if (currentPayload.sectionName && currentPayload.strength && currentPayload.teacher) {
            return true
        }
        return false
    }

    onSelectMathTeacher(option) {
        let currentPayload = {
            ...this.state.currentPayload,
            teacher: option?.value
        }

        let completed = this.checkCompletedStatus(currentPayload)
        let sections = this.state.sections
        sections[this.state.selectedHeader].completed = completed

        this.setState({ currentPayload, sections }, () => {
            this.emitChanges()
        })
    }

    onClickNext = () => {
        let currentIndex = this.state.selectedHeader + 1
        let sectionCount = this.props.numberOfSections + this.props.oldSection?.length || 0
        if (currentIndex < sectionCount) {
            this.onClickHeader(this.state.sections[currentIndex], currentIndex)
        }
    }

    onClickSave = () => {

        let payload = {
            _id: this.props.sectionDetails?._id,
            sectionName: this.state.currentPayload.sectionName,
            teacher: this.state.currentPayload.teacher,
            strength: this.state.currentPayload.strength,
        }

        if (!this.validateSectionPayload(this.state.currentPayload)) return

        SchoolApi.updateSchoolSection(payload)
            .then(staffs => {
                this.props.onSave(true)
            }).catch(err => {
            })
    }

    validateSectionPayload(section) {

        if (!section.sectionName) {
            this.setState({ errorMessage: `Please enter name for section ${section.order}` })
            return false
        }
        if (!section.teacher) {
            this.setState({ errorMessage: `Please select math teacher for section ${section.order}` })
            return false
        }

        return true

    }

    onSuccessUploadExcel = (res) => {

        if (res.data) {

            let students = this.extractFromExcel(res?.data || [])
            let currentPayload = {
                ...this.state.currentPayload,
                excelFileName: res?.fileName || "",
                students
            }
            this.setState({ currentPayload }, () => {
                this.emitChanges()
            })
            return
        }

        if (res.error) {
            this.setState({ errorMessage: "Excel upload error" })
        }
    }

    extractFromExcel(data) {
        let studentsList = []

        for (let i = 0; i < data.length; i++) {
            let obj = data[i]
            let student = {
                name: obj["Name"],
                contactNumber: obj["Contact Number"],
                contactEmail: obj["Contact Email"],
                countryCode: obj["Country Code"],
                rollNumber: obj["Roll Number"],
                previousYearMarks: obj["Previous Year Mark"],
                type: obj["Type"],
            }
            studentsList.push(student)
        }

        return studentsList
    }

    removeExcelFile() {
        let currentPayload = {
            ...this.state.currentPayload,
            excelFileName: "",
            students: []
        }

        this.setState({ currentPayload }, () => {
            this.emitChanges()
        })
    }

    emitChanges = () => {
        if (this.props.mode == "EDIT") return
        let payload = {}
        for (let i = 0; i < this.props.numberOfSections; i++) {
            payload[i + 1] = this.state[i + 1] || {}
        }
        payload[this.state.currentActiveSectionOrder] = {
            ...this.state.currentPayload
        }
        if (this.props.onChange) {
            this.props.onChange(payload)
        }
    }

    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = 'https://docs.google.com/spreadsheets/d/1gsgNHBwshq0lY5NLYcLbCHSqvSc_tpQ_gGhn50k2gfI/edit?usp=sharing';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    addNewTeacher = () => {
        this.setState({ showAddNewTeacher: true })
    }

    hideNewTeacher = (selectedTeacherId) => {
        this.setState({ showAddNewTeacher: false })
        if (selectedTeacherId) {
            let currentPayload = {
                ...this.state.currentPayload,
                teacher: selectedTeacherId
            }

            let completed = this.checkCompletedStatus(currentPayload)
            let sections = this.state.sections
            sections[this.state.selectedHeader].completed = completed

            this.setState({ currentPayload, reloadDropdown: true, sections }, () => {
                this.emitChanges()
                this.setState({ reloadDropdown: false })
            })
        }
        this.getStaffs()
    }

    renderAddNewContactModal() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNewTeacher} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideNewTeacher} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>{"ADD NEW TEACHER"}</span>
                    </div>
                    <div className="px-4">
                        <AddNewTeacher show={this.state.showAddNewTeacher} onClose={this.hideNewTeacher} size={'lg'} />
                    </div>
                </ModalBody>
            </Modal>)
    }


    renderAddNewContactModalRightSide() {
        return (
            <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.hideNewTeacher} size={"lg"}>
                <ModalBody >
                    <div className="setup-class-dashboard">
                        <div className="abs-image">
                            <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                        </div>

                        <div className="pt-4 my-auto">
                            <span className="step-title">STEP 2</span>
                            <span className="float-right">
                                <img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.hideNewTeacher} />
                            </span>
                        </div>
                        <div className="pt-4 header-title">ADD A TEACHER</div>

                        <AddNewTeacher show={this.state.showAddNewTeacher} hideDefaultType onClose={this.hideNewTeacher} size={'lg'} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    render() {
        return (
            <div className="add-section">
                <div className={`section-tab`}>
                    <div className="px-4">
                        <div className="section-header" id="section-scroll">
                            {
                                this.state?.sections ? this.state?.sections.map((item, index) => (
                                    <div className={`d-inline-block px-4 py-2 curosor-pointer ${this.state.selectedHeader == index ? "active-section-header" : "inactive-section-header"} ${index == 0 ? "left-border" : ""}`}
                                        onClick={() => this.onClickHeader(item, index)}>
                                        <div className="">
                                            <span className="pr-2"> {item.completed ? <img className="tab-image" src={getImageSource(ImageConstants.CORRECT)} /> : ""}</span>
                                            {!item.completed && (this.state.selectedHeader == index) ? <span className="d-inline-block in-progress mr-2"></span> : ""}
                                            <span>{item?.title}</span>
                                        </div>
                                    </div>
                                ))
                                    : ""
                            }
                        </div>
                    </div>
                    <div className="cw-gradiant-card">
                        <div className="cw-gradiant-card-content">
                            <div className='row bw-spaces-input'>
                                <div className='col'>
                                    <label className='cw-input-label'>SECTION </label>
                                    <input className={`cw-input ${this.state.isSubmit && !this.state.currentPayload?.sectionName ? "invalid" : ""}`} placeholder='Enter Section'
                                        value={this.state.currentPayload?.sectionName || ""}
                                        onChange={(e) => this.onChangeHandler(e, 'sectionName')}
                                        disabled={this.state.currentPayload?.notEditable}
                                    />
                                </div>
                            </div>

                            <div className='row bw-spaces-input'>
                                <div className='col'>
                                    <label className='cw-input-label'>CLASS STRENGTH</label>
                                    <input className={`cw-input ${this.state.isSubmit && !this.state.currentPayload?.strength ? "invalid" : ""}`} placeholder='Enter Class Strength'
                                        value={this.state.currentPayload?.strength || ""}
                                        onChange={(e) => this.onChangeHandler(e, 'strength')} />
                                </div>
                            </div>

                            <div className='row bw-spaces-input'>
                                <div className='col-11 pr-0'>
                                    <label className='cw-input-label'>MATH TEACHER </label>
                                    {
                                        !this.state.reloadDropdown ?
                                            <Dropdown
                                                placeholder='Select'
                                                options={this.state?.mathTeacherDropdown}
                                                onSelect={(option) => this.onSelectMathTeacher(option)}
                                                text={"title"}
                                                style={{ background: "#F6F7F5" }}
                                                value={this.state.currentPayload?.teacher || ""}
                                                invalid={this.state.isSubmit && !this.state.currentPayload?.teacher}
                                            /> : ""}
                                </div>
                                <div className='col-1 add-icon-wrapper my-auto '>
                                    <img className="custom-add-icon cursor-pointer pt-4" onClick={this.addNewTeacher} src={getImageSource(ImageConstants.ADD)} />
                                </div>
                            </div>

                            {
                                !this.props.disableAddStudent ?
                                    <div className='row bw-spaces-input'>
                                        <div className='col'>
                                            <label className='cw-input-label'>ADD STUDENT VIA BULK EXCEL UPLOAD</label>
                                            <div className="import-excel-div ">
                                                <label className="py-2 px-4 m-0">
                                                    {this.state.currentPayload?.excelFileName || ""}
                                                </label>
                                                {
                                                    this.state.currentPayload?.excelFileName ?
                                                        <label className="excel float-right text-danger py-2 px-4 m-0" onClick={() => this.removeExcelFile()}>
                                                            REMOVE EXCEL
                                                        </label> :
                                                        <label className="excel float-right text-success py-2 px-4 m-0">
                                                            <ExcelToJson onSuccess={this.onSuccessUploadExcel} />
                                                            ADD EXCEL
                                                        </label>
                                                }
                                            </div>
                                            <div className='check-text text-right mt-1' onClick={this.showExcelFormat}>View Sample Here</div>
                                            <div className="note-text text-success">NOTE: Students could be added by Teacher as well</div>
                                        </div>
                                    </div>
                                    : ""
                            }

                            {
                                this.props.mode != "EDIT" && this.state.selectedHeader != this.state.sections.length - 1 ?
                                    <div className='mt-4'>
                                        <div className='cw-button-sm' onClick={this.onClickNext}>
                                            Next
                                        </div>
                                    </div>
                                    : ""
                                // <div className='mt-4 text-center'>
                                //     <div className='cw-button-sm' onClick={this.onClickSave}>
                                //         SAVE
                                //     </div>
                                // </div>
                            }
                        </div>
                    </div>
                </div>
                {
                    this.state.showAddNewTeacher && this.props.modalType == "RIGHT" ? this.renderAddNewContactModalRightSide() : ""
                }
                {
                    this.state.showAddNewTeacher && this.props.modalType != "RIGHT" ? this.renderAddNewContactModal() : ""
                }
            </div >
        )
    }
}

export default AddSection;